import { Button, SparkleIcon } from '@iheartjane/reefer';

interface WizardButtonProps {
  onClickStart: () => void;
}

export const WizardButton = ({ onClickStart }: WizardButtonProps) => {
  return (
    <Button
      data-testid="wizard-button"
      label="Help me choose"
      onClick={onClickStart}
      startIcon={<SparkleIcon size="sm" />}
    />
  );
};
